import * as rmd from 'material-ui';
import React from 'react';

class SelectPicker extends React.Component {
    static defaultProps = {
        options: []
    };

    constructor(props, context) {
        super(props, context);
        var initState = {};

        try {
            initState.value = JSON.parse(props[props.propKey]);
        } catch (e) {
            initState.value = props[props.propKey] || null;
        }
        this.state = initState;
    }

    componentWillReceiveProps = nextProps => {
        let value = null;
        try {
            value = JSON.parse(nextProps[nextProps.propKey]);
        } catch (e) {
            value = nextProps[nextProps.propKey] || null;
        }
        this.setState({ value });
    };

    renderOption(option) {
        return <rmd.MenuItem key={option.value} value={option.value} primaryText={option.text} />;
    }

    handleChange = (e, key, payload) => {
        this.props.onChange(this.props.propKey, payload);
        this.setState({ value: payload });
    };

    render() {
        return (
            <div>
                <rmd.SelectField
                    style={{ width: '100%' }}
                    value={this.state.value}
                    floatingLabelText={this.props.label}
                    floatingLabelFixed
                    onChange={this.handleChange}
                >
                    {this.props.options.map(this.renderOption)}
                </rmd.SelectField>
            </div>
        );
    }
}

export default SelectPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/SelectPicker.js
 **/